<template>
  <div>
          <div>
      <div class="info mt15">
        <div class="tip">计费状态</div>
      </div>
      <el-divider class="divider"></el-divider>
      <el-table
        class="m-table"
        :data="costTableData"
        style="width: 100%"
        stripe
      >
        <el-table-column prop="busiDetailType" label="计费名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.costName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="busiDetailType" label="业务名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.busiDetailType | formatBusiDetailType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
        </el-table-column>
        <el-table-column prop="packageCycle" label="结算周期">
          <template slot-scope="scope">
            <span>{{ scope.row.packageCycle }}个月</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="计费规则" width="180">
        </el-table-column>
        <el-table-column prop="packageUnit" label="累计费用（元）">
        </el-table-column>
        <el-table-column prop="number" label="累计使用次数">
        </el-table-column>
        <el-table-column prop="status" label="状态"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="120px">
          <template slot-scope="scope">
            <el-button @click="costDetail(scope.row)" type="text">
              详情</el-button
            >
            <!-- <template v-if="getUserIdentity == 4 && scope.row.PackageUsageState == 3"> -->
            <template v-if="getUserIdentity == 4">
              <template v-if="scope.row.packageFinanceState != 2">
                <el-divider direction="vertical"></el-divider>
                <Settlement @refreshSettle="refreshSettle" :row="scope.row">
                  <span slot="title">
                    <el-button type="text" @click="jsDialog(scope.row)"
                      >结算</el-button
                    >
                  </span>
                </Settlement>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total2 > 0" class="pagination">
        <Pagination
          :total="total2"
          :pageSizes="pageSizes"
          @handleSizeChange="handleSizeChange2"
          @handleCurrentChange="handleCurrentChange2"
          :currentPage="currentPage2"
          :pageSize="pageSize2"
        ></Pagination>
      </div>
    </div>
    <div>
      <div class="info mt15">
        <div class="tip">结算状态</div>
      </div>
      <el-divider class="divider"></el-divider>
      <el-table
        class="m-table"
        :data="packagetableData"
        style="width: 100%"
        stripe
      >
        <el-table-column prop="busiDetailType" label="业务名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.busiDetailType | formatBusiDetailType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="开始时间" width="180">
        </el-table-column>
        <el-table-column prop="packageCycle" label="结算周期">
          <template slot-scope="scope">
            <span>{{ scope.row.packageCycle }}个月</span>
          </template>
        </el-table-column>
        <el-table-column prop="packageUnit" label="单价（元）">
        </el-table-column>
        <el-table-column label="累计使用次数" prop="1">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.packageNum - scope.row.remainNo }}</span> -->
            <span>{{ scope.row.usedNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalMoney" label="当前总价（元）">
        </el-table-column>
        <el-table-column prop="a" label="结算状态">
          <template slot-scope="scope">
            <span
              :class="{
                'ft-blue': scope.row.packageFinanceState == 1,
                'ft-gray': scope.row.packageFinanceState == 2,
              }"
              >{{
                scope.row.packageFinanceState | formatPackageFinanceState
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120px">
          <template slot-scope="scope">
            <el-button @click="jsviewDetail(scope.row)" type="text">
              详情</el-button
            >
            <template v-if="getUserIdentity == 4">
              <template v-if="scope.row.packageFinanceState != 2">
                <el-divider direction="vertical"></el-divider>
                <Settlement @refreshSettle="refreshSettle" :row="scope.row">
                  <span slot="title">
                    <el-button type="text" @click="jsDialog(scope.row)"
                      >结算</el-button
                    >
                  </span>
                </Settlement>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total2 > 0" class="pagination">
        <Pagination
          :total="total2"
          :pageSizes="pageSizes"
          @handleSizeChange="handleSizeChange2"
          @handleCurrentChange="handleCurrentChange2"
          :currentPage="currentPage2"
          :pageSize="pageSize2"
        ></Pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "costDetails",
  data(){
      return {
          packagetableData:[]
      }
  }
};
</script>
<style lang="scss" scoped></style>
